import React from 'react';

export enum TipBannerRadiusSize {
    MD = 'md',
    SM = 'sm'
}

export enum TipBannerVariant {
    HORIZONTAL = 'horizontal',
    VERTICAL = 'vertical'
}

interface ITipBannerProps {
    // attributes
    analytics?: string;
    isDark?: boolean;
    forcedBorderRadius?: TipBannerRadiusSize;
    variant?: TipBannerVariant;
}

export const TipBanner: React.FC<ITipBannerProps> = ({
    // attributes
    analytics,
    isDark = false,
    forcedBorderRadius = null,
    variant,
    children
}) => (
    // @ts-ignore
    <dsd-tip-banner
        analytics={analytics}
        dark={isDark}
        forced-border-radius={forcedBorderRadius}
        variant={variant}
    >
        {children}
        {/* @ts-ignore */}
    </dsd-tip-banner>
);
